import { render, staticRenderFns } from "./helpComp.vue?vue&type=template&id=9677016a&scoped=true&"
import script from "./helpComp.vue?vue&type=script&lang=js&"
export * from "./helpComp.vue?vue&type=script&lang=js&"
import style0 from "./helpComp.vue?vue&type=style&index=0&id=9677016a&scoped=true&lang=css&"
import style1 from "./helpComp.vue?vue&type=style&index=1&id=9677016a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9677016a",
  null
  
)

export default component.exports